import ApiService from '@/core/services/api.service'

//Action types
export const GET_CONFIGURACIONES = "getConfiguraciones";
export const UPDATE_CONFIGURACION = "updateConfiguracion";

//Mutadores
export const SET_ERROR = "setError"

//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
// const url = "https://localhost:44340"

const state = {
    error: null,
    cajeros: []
}

const actions = {
    [GET_CONFIGURACIONES](context){
        return new Promise((resolve) => {
            ApiService.setHeader();
            ApiService.get({ action: '/facturacioncomisionapi/api/Configuracion/v1/Configuraciones' }, '')
            .then(({data}) => {
                resolve(data);
            })
            .catch(({response}) => {
                context.commit(SET_ERROR, '')
            })
        })
    },
    [UPDATE_CONFIGURACION](context, configuracion){
        return new Promise((resolve, reject) => {
            ApiService.put({action: '/facturacioncomisionapi/api/Configuracion/v1/Configuracion/'}, configuracion)
            .then(({data}) => {
                resolve(data)
            })
            .catch(({response})=> {
                reject(response)
            })
        })
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error
    }
}

export default {
    state,
    actions,
    mutations
}
